import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Agent from '../agent';

const initialState = {
  loading: false,
  available_chains: {},
  chain_total_amounts: {},
  token_chain_breakdown: [],
  protocol_chain_breakdown: [],
  errors: {},
};

// These are redux/toolkit async thunk for performing api call
// There methods are automatically attached to reducers and actions below
export const getChainInfo = createAsyncThunk(
  'defi/chainInfo/getInfo',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await Agent.Defi.Chains.getInfo(payload);
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

export const getWalletDefiChain = createAsyncThunk(
  'defi/overview/chain/:wallet',
  async (data, { rejectWithValue }) => {
    return Agent.Defi.Overview.walletChain(data)
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        if (!error.response) {
          return rejectWithValue({ errors: { [error.name]: error.message } });
        }
        return rejectWithValue(error.response.body);
      });
  }
);

const chainSlice = createSlice({
  name: 'defi',
  initialState,
  reducers: {
    setLoading(state) {
      state.loading = true;
    },
  },
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit
    [getChainInfo.pending]: (state) => {
      state.loading = true;
    },

    [getChainInfo.fulfilled]: (state, action) => {
      state.loading = false;
      if (action?.payload) {
        state.available_chains = action?.payload?.data?.available_chains || {};
        state.token_chain_breakdown = action?.payload?.data?.token_chain_breakdown || [];
        state.protocol_chain_breakdown = action?.payload?.data?.protocol_chain_breakdown || [];
        state.chain_total_amounts = action?.payload?.data?.chain_total_amounts || {};
      }
    },

    [getChainInfo.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },

    [getWalletDefiChain.pending]: (state) => {
      state.loading_chain_data = true;
    },
    [getWalletDefiChain.fulfilled]: (state, action) => {
      state.loading_chain_data = false;
      let {
        chain_asset_breakdown,
        chain_total_amounts,
        token_chain_breakdown,
        protocol_chain_breakdown,
        available_chains,
      } = action.payload;
      state.chain_asset_breakdown = chain_asset_breakdown || [];
      state.available_chains = available_chains || [];
      state.token_chain_breakdown = token_chain_breakdown || [];
      state.chain_total_amounts = chain_total_amounts || [];
      state.protocol_chain_breakdown = protocol_chain_breakdown || [];
    },
    [getWalletDefiChain.rejected]: (state, action) => {
      state.loading_chain_data = false;
      state.errors = action?.payload?.errors || {};
    },
  },
});

export const defiChainSelector = (state) => state.defiChain;

export const { reducer, actions } = chainSlice;
